import ViewPayments from 'components/PaymentHistory/ViewPayments.component';

const ViewPaymentHistory = () => {
	return <ViewPayments />;
};

export default ViewPaymentHistory;
